import React from 'react'


export default function SocialIcons() {

  return (
    <div class="social-menu">
         <ul>
            <li><a href="https://github.com/Logeshwaran95" target="blank"><i class="fab fa-github"></i></a></li>
            <li><a href="https://www.linkedin.com/in/logeshwaran-/" target="blank"><i class="fab fa-linkedin-in"></i></a></li>
            <li><a href="https://www.instagram.com/logeshsiva95/" target="blank"><i class="fab fa-instagram"></i></a></li>

            {/* <li><a href=""><i class="fab fa-codepen" target="blank"></i></a></li> */}
            <li><a href="https://twitter.com/Logeshwaran395" target="blank"><i class="fab fa-twitter" target="blank"></i></a></li>
            
         </ul>
   
        
        </div>
  )
}
